<template>
    <div v-if="loginData">
        <form @submit.prevent="login">
            <fieldset :disabled="loading">
                <p v-if="loginData.Mobile">
                    <span v-html="translate('login.sentToMobileNumberWithField:'+ loginData.Mobile)"></span>
                    <!-- <b>{{loginData.Mobile}}</b> numaralı telefonunuza doğrulama kodu SMS olarak gönderilmiştir ve kısa süre içerisinde ulaşacaktır.  -->
                </p>
                <p v-else>
                    {{translate('login.sentToMobileNumberWithoutField')}}
                </p>

                <div class="form-group">
                    <label>{{translate('login.enterMobileValidationCode')}}</label>
                    <input v-model="loginData.OTP" type="text" class="form-control text-center" aria-describedby="validationCodeHelp" required />
                </div>                
                <button type="submit" class="btn btn-success btn-block">{{translate('send')}}</button>
                <div v-if="errorMessage" class="text-danger">{{translate('login.error')}} {{errorMessage}}</div>
            </fieldset>
        </form>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoginWithMFA',
  props: {
    loginData : Object
  },
  created(){
      if(this.loginData == null)
        this.$router.push('/');
  },
  data: () => ({
    loading: false,
    errorMessage : null
  }),
  methods: {
    async loginWithMFA(accountCode, email, sessionId, OTP){
        const {data} = await axios.post("/token/postMFA", { accountCode, email, sessionId, OTP });
        return data;
    },
    login(){
        console.log('Oluşturuldu:', this);
        this.loading = true;
        this.loginWithMFA(this.loginData.AccountCode, this.loginData.Email, this.loginData.SessionId, this.loginData.OTP)
        .then(x => {
            this.errorMessage = null;
            console.log("Gelen sonuç:", x);
            if(x.Success) {
                window.localStorage.setItem('user', JSON.stringify(x.Data));
                axios.defaults.headers.common['token'] = x.Data.Key;
                this.$root.$data.login = x.Data;

                window.localStorage.setItem('accountCode', x.Data.Account.Code);
				window.localStorage.setItem('email', x.Data.User.Email);

                if(this.$route.query.redirect)
                    this.$router.push(this.$route.query.redirect);
                else
                    this.$router.push('/' + x.Data.Account.Code);
            } 
            else 
            {
                this.errorMessage = x.ErrorMessages;
                this.loginData.OTP = '';
                this.loading = false;
            }
            console.log('Token geldi: ', axios.defaults.headers.common['token']);
        }).catch(e => {
            console.log('Error:', e);
            this.loginData.OTP = '';
            if(e.response === undefined) {
                this.errorMessage = this.translate('errors.cantConnectError');
            } else if(e.response.status == 400){
                this.errorMessage = window.getModelStateString(e.response.data.ModelState) || e.response.data.Message;
            } else {
                this.errorMessage = this.translate('errors.unexpectedError');
            }
            this.loading = false;
        })        
    }
  }
}
</script>